
<!--  -->
<template>
  <div class="comContent contentInner">
    <div class="titleInner">
      <MyTabs class="search" :tabi="tabsIndex" keyname="val" :tabs="tabsData" @change="tabChange" />
      <div class="title">
        <el-form ref="formTool" :model="formTool" :inline="true">

          <span v-if="expanded">
            <el-form-item prop="orderCode">
              <el-input v-model="formTool.orderCode" clearable placeholder="请输入订单编号" size="small" />
            </el-form-item>
            <el-form-item prop="code">
              <el-input v-model="formTool.code" clearable placeholder="请输入售后单号" size="small" />
            </el-form-item>
            <el-form-item prop="shopName">
              <el-input v-model="formTool.shopName" clearable placeholder="请输入申请人" size="small" />
            </el-form-item>
          </span>
          <span v-if="!expanded">
            <el-form-item prop="keyWords">
              <el-input v-model="formTool.keyWords" clearable placeholder="订单编号/售后单号/申请人" size="small"
                style="width: 300px;" />
            </el-form-item>
          </span>
          <el-form-item>
            <MyButton type="primary" text="查询" @click="goSearch" />
          </el-form-item>
          <el-form-item>
            <el-button size="small" @click="reset()">重置</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="text" size="small" @click="handleExpand()">
              {{ expanded ? "收起" : "展开"
              }}<i :class="{
    'el-icon-arrow-up': expanded,
    'el-icon-arrow-down': !expanded,
    'el-icon--right': true,
  }"></i>
            </el-button>
          </el-form-item>

        </el-form>
      </div>

    </div>
    <div class="center">
      <MyTable :table-data="tableData" :index="index" :selection="selection" :page="page" :operation="operation"
        :table-option.sync="tableOption" @page-change="getcheckList" @handleSelectionChange="currentChange"
        @sort-change="sortChange">
        <!-- <template slot="image" slot-scope="scope">
          <el-image :src="scope.row.image" style="width: 80px; height: 80px" />
        </template> -->
        <!-- <template slot="status"
                  slot-scope="scope">
          <MyTypes :type="scope.row.status" />
        </template>
        <template slot="address"
                  slot-scope="scope">
          <p>{{ scope.row.provinceName + scope.row.cityName + scope.row.areaName + scope.row.address }}</p>
        </template> -->
        <template slot="shengyushijian" slot-scope="scope">
          <el-statistic ref="statistic" format="HH:mm:ss"
            :value="scope.row.evidenceRemainTimestamp ? Date.now() + Number(scope.row.evidenceRemainTimestamp) : 0"
            title="" time-indices>
          </el-statistic>
        </template>
        <template slot="caozuo" slot-scope="scope">
          <el-link :underline="false" type="primary" @click="editDetail(scope.row)">查看详情</el-link>
          <el-link :underline="false" v-if="scope.row.platformStatus == 'PENDING'" style="margin-left:10px" type="primary"
            @click="agree(scope.row)">同意售后</el-link>
          <el-link :underline="false" v-if="scope.row.platformStatus == 'PENDING'" style="margin-left:10px" type="primary"
            @click="reject(scope.row)">驳回售后</el-link>
        </template>
      </MyTable>
    </div>
    <el-dialog title="驳回原因" :visible.sync="rejectDialogShow" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="130px" class="demo-ruleForm">
        <el-form-item label="驳回原因" prop="remark">
          <el-input v-model="ruleForm.remark" clear size="small" style="width: 190px;"></el-input>
        </el-form-item>
        <el-form-item label="上传图片" prop="rejectImg">
          <ImgUpload v-model="ruleForm.rejectImg" :isEdit="false" :limit="5" style="position:relative;top:-8px">
            <template slot="tip">
              <p class="el-upload__tip" style="margin:0px">
                上传图片大小需低于2M，图片格式PNG,JPG,JPEG，页面中图片建议尺寸100*100
              </p>
            </template>
          </ImgUpload>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="submitForm('ruleForm')">确认</el-button>
          <el-button size="small" @click="resetForm('ruleForm')">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import MyButton from '@/components/myButton'
import MyTable from '@/components/myTable'
import MyTabs from '@/components/myTabs'
import MyTypes from '@/components/myTypes'
import ImgUpload from '@/components/imgUpload'
import { auditTypes } from '@/utils/enumeration'
import { aftersalePlatformPage, aftersalePlatformrReject, aftersalePlatformrAgree } from '@/api/auditcenter'
import router from '@/router'

export default {
  components: { MyButton, MyTable, MyTabs, MyTypes, ImgUpload },
  data () {
    return {
      desc: false,
      expanded: false,
      text: '',
      clearable: true,
      formTool: {
        code: '',
        shopName: '',
        orderCode: ''
      },
      tabsData: [
        { name: '待处理', num: 0, val: 'PENDING', numhide: false },
        { name: '商户待举证', num: 0, val: 'WAIT_EVIDENCE', numhide: false },
        { name: '同意售后', num: 0, val: 'AGREE', numhide: true },
        { name: '驳回', num: 0, val: 'REJECT', numhide: true },
      ],
      tabsIndex: 'PENDING',
      operation: false,
      selection: false,
      index: false,
      tableData: [],
      tableOption: [
        { label: '申请人', prop: 'payShopName' },
        { label: '客户联系方式', prop: 'contactsPhone' }, // 这里表示自定义列 , slot: true
        { label: '售后商品', prop: 'goodsName' },
        { label: '售后单据类型', prop: 'type' },
        { label: '申请时间', prop: 'orderTime' },
        { label: '订单编号', prop: 'orderCode' },
        { label: '售后单号', prop: 'code' },
        { label: '售后商户', prop: 'payeeShopName' },
        { label: '商户联系方式', prop: 'payeeShopPhone' },
        { label: '操作', prop: 'caozuo', slot: true, width: '200' }
      ],
      page: {
        total: 10,
        current: 1,
        size: 10
      },
      rejectDialogShow: false,
      ruleForm: {
        remark: '',
        rejectImg: [],
      },
      rejectId: '',//驳回时弹窗临时记录id
      rules: {
        remark: [
          { required: true, message: '请输入驳回原因', trigger: 'blur' }

        ]
      }
    }
  },
  computed: {},
  watch: {},
  created () {
    if (this.$route.query.status) {
      this.tabsIndex = this.$route.query.status
    }
    this.getcheckList()
  },
  mounted () {

  },
  methods: {
    submitForm () {
      let _this = this
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          let imgListStr = ''
          if (this.ruleForm.rejectImg.length) {
            imgListStr = this.ruleForm.rejectImg.join(',')
          }
          aftersalePlatformrReject(
            {
              id: _this.rejectId,
              rejectReason: _this.ruleForm.remark,
              rejectVoucher: imgListStr
            }
          ).then(res => {
            _this.rejectDialogShow = false
            if (res.code == 0) {
              _this.$message.success('驳回已通过')
              _this.goSearch()
            } else {
              _this.$message.error('驳回失败')
            }
          })
        }
      })
    },
    resetForm () {
      this.ruleForm.remark = ''
      this.ruleForm.rejectImg = []
      this.rejectDialogShow = false
    },
    tabChange (i) {
      console.log('i:' + i)
      if (i == 'WAIT_EVIDENCE') {
        this.tableOption = [
          { label: '申请人', prop: 'payShopName' },
          { label: '客户联系方式', prop: 'contactsPhone' }, // 这里表示自定义列 , slot: true
          { label: '售后商品', prop: 'goodsName' },
          { label: '售后单据类型', prop: 'type' },
          { label: '申请时间', prop: 'orderTime' },
          { label: '订单编号', prop: 'orderCode' },
          { label: '售后单号', prop: 'code' },
          { label: '售后商户', prop: 'payeeShopName' },
          { label: '商户联系方式', prop: 'payeeShopPhone' },
          { label: '剩余举证时间', prop: 'shengyushijian', sortable: true, width: '140', slot: true, },
          { label: '操作', prop: 'caozuo', slot: true, width: '200' }
        ]
      } else {
        this.tableOption = [
          { label: '申请人', prop: 'payShopName' },
          { label: '客户联系方式', prop: 'contactsPhone' }, // 这里表示自定义列 , slot: true
          { label: '售后商品', prop: 'goodsName' },
          { label: '售后单据类型', prop: 'type' },
          { label: '申请时间', prop: 'orderTime' },
          { label: '订单编号', prop: 'orderCode' },
          { label: '售后单号', prop: 'code' },
          { label: '售后商户', prop: 'payeeShopName' },
          { label: '商户联系方式', prop: 'payeeShopPhone' },
          { label: '操作', prop: 'caozuo', slot: true, width: '200' }
        ]
      }
      this.tabsIndex = i
      this.page.current = 1
      this.getcheckList()
    },
    getcheckList () {
      const { current, size } = this.page
      const params = {
        current, size, status: this.tabsIndex,
        ...this.formTool
      }
      if (this.tabsIndex == 'WAIT_EVIDENCE') {
        params.desc = this.desc
      }
      aftersalePlatformPage(params).then(res => {
        if (res.code === 0) {
          const { records, total } = res.data.page
          this.page.total = total
          this.tabsData[0].num = res.data.pendingQty
          this.tabsData[1].num = res.data.waitEvidenceQty
          // 当待处理事项 全部处理完以后,更新菜单红点提示
          this.tableData && this.tableData.length > 0 && this.updateMenuDot(res)
          // records.forEach(item => {
          //   item.status = auditTypes(item.status)
          // })
          this.tableData = records
          // if (this.tabsIndex == '0') {
          //   this.tabsData[0].num = total
          // }
        }
      })
    },
    /**
     * 设置菜单红点
     */
    updateMenuDot (res) {
      //当待处理事项 全部处理完以后,才做菜单更新
      if (!res || res.data.pendingQty != 0) {
        return
      }
      this.$store.dispatch('ClearRoutesDot', this.$route.path )
    },
    reset () {
      // this.formTool.storeName = ''
      this.$refs.formTool.resetFields()
      this.page.current = 1
      this.getcheckList()
    },
    // 查看详情
    editDetail (row) {
      this.$router.push({ path: '/audit/auditcenter-salesDetail', query: { afterSaleId: row.id } })
    },
    // 同意
    agree (row) {
      aftersalePlatformrAgree(
        {
          id: row.id
        }
      ).then(res => {
        if (res.code == 0) {
          this.$message.success('审核已通过')
          this.goSearch()
        } else {
          this.$message.error('审核失败')
        }
      })
    },
    // 驳回 
    reject (row) {
      this.rejectId = row.id
      this.rejectDialogShow = true

    },
    currentChange (val) {
      console.log('current', val)
    },
    goSearch () {
      const { code, orderCode, shopName } = this.formTool
      this.page.current = 1
      this.getcheckList()
    },
    handleExpand () {
      this.expanded = !this.expanded;
    },
    sortChange (res) {
      console.log(res)
      if (res.order == 'descending') {
        this.desc = true
      } else {
        this.desc = false
      }
      this.getcheckList()
    },
    // pageChange(val) {
    //   console.log('page', val)
    // },
    // handleSelectionChange(val) {
    //   console.log(val)
    // }
  }
}
</script>
<style lang='scss' scoped>
.comContent {
  .titleInner {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #eee;
    padding: 0px 24px;

    .title {
      display: flex;
      justify-content: right;
      align-items: center;

      .el-form--inline {
        .el-form-item {
          margin-bottom: 0px !important;
        }
      }
    }

    .search {
      align-items: center;
    }
  }

  ::v-deep .con {

    color: #595959;

    .number {
      font-size: 14px;
    }
  }
}

.contentInner {
  padding: 0px;
}

.center {
  margin-top: 16px;
  padding: 0px 24px;
  height: calc(100% - 136px);
}
</style>
